import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';
// import { requestFavouritedUsersWhereabouts } from '@features/whereabouts/services/Movements';
import { MemberMovements, UsersWhereaboutsDay } from '@features/whereabouts/models/movements.models';
import { requestFavouritedUsersWhereabouts } from '@features/whereabouts/services/Movements';
import { DATE_FORMAT } from "@shared/utils/DateUtils";

export interface FavouritedUsersWhereaboutsState {
  whereabouts: MemberMovements[];
  loading: boolean;
  isFavouritedUserOptionSelected: boolean;
}

export const initialFavouritedUsersWhereaboutsState: FavouritedUsersWhereaboutsState = {
  whereabouts: [],
  loading: false,
  isFavouritedUserOptionSelected: false,
}

export const loadFavouritedUsersWhereabouts: any = createAsyncThunk('favouritedUsersWhereabouts/load',
  async (params: {date: string}, thunkAPI) => {
    const state = (thunkAPI.getState() as AppState);
    if (params.date && state.favouritedUsersWhereabouts.isFavouritedUserOptionSelected) {
      const resp = await requestFavouritedUsersWhereabouts(params.date);
      return resp;
    }
    return [];
  }
);

const loadWhereaboutsIfVisible: any = createAsyncThunk('favouritedUsersWhereabouts/updateWhereaboutsIfVisible',
  async (params: any, thunkAPI) => {
    const state = (thunkAPI.getState() as AppState)
    if (state.favouritedUsersWhereabouts.isFavouritedUserOptionSelected) {
      thunkAPI.dispatch(loadFavouritedUsersWhereabouts(state.dashboard.calendarDate.format(DATE_FORMAT)))
    }
  }
);

export const updateFavouritedUsersWhereabouts: any = createAsyncThunk('favouritedUsersWhereabouts/updateWhereabouts',
  async (params: {whereaboutsToReplace: UsersWhereaboutsDay}, thunkAPI) => {
    const state = (thunkAPI.getState() as AppState);
    const lineReports = state.favouritedUsersWhereabouts.whereabouts;

    const updatedFavouritedUsersWhereabouts = lineReports.map((favouritedUsersWhereabouts: MemberMovements) => {
      if (favouritedUsersWhereabouts.id === params.whereaboutsToReplace.userId) {
        const whereaboutsForDate = (favouritedUsersWhereabouts.whereabouts ?? []).find(w => w.date === params.whereaboutsToReplace.date);
        if (whereaboutsForDate) {
          const filteredWhereabouts = (favouritedUsersWhereabouts.whereabouts ?? []).filter(w => w.date !== params.whereaboutsToReplace.date);
          return {
            ...favouritedUsersWhereabouts,
            whereabouts: [...filteredWhereabouts, params.whereaboutsToReplace],
          };
        } else {
          return {
            ...favouritedUsersWhereabouts,
            whereabouts: [...favouritedUsersWhereabouts.whereabouts, params.whereaboutsToReplace],
          }
        }
      }
      return favouritedUsersWhereabouts;
    });

    return updatedFavouritedUsersWhereabouts;
  }
);

const favouritedUsersWhereaboutsSlice = createSlice({
  name: 'favouritedUsersWhereabouts',
  initialState: initialFavouritedUsersWhereaboutsState,
  reducers: {
    reset: () => ({...initialFavouritedUsersWhereaboutsState}),
    setFavouritedUsersWhereaboutsSelected: (state, action) => ({...state, isFavouritedUserOptionSelected: action.payload}),
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadFavouritedUsersWhereabouts.pending, (state) => ({ ...state, whereabouts: [], loading: true }))
      .addCase(loadFavouritedUsersWhereabouts.rejected, (state) => ({ ...state, whereabouts: [], loading: false }))
      .addCase(loadFavouritedUsersWhereabouts.fulfilled, (state, action) => ({
      ...state,
      whereabouts: action.payload,
      loading: false,
    }))
      .addCase(updateFavouritedUsersWhereabouts.fulfilled, (state, action) => ({
      ...state,
      whereabouts: action.payload,
      loading: false,
    }));
  }
})

export default favouritedUsersWhereaboutsSlice.reducer;
export const { setFavouritedUsersWhereaboutsSelected } = favouritedUsersWhereaboutsSlice.actions;

// Selectors
export const selectFavouritedUsersWhereabouts = (state: AppState) => state.favouritedUsersWhereabouts.whereabouts;
export const selectIsLoading = (state: AppState) => state.favouritedUsersWhereabouts.loading;
export const selectIsFavouritedUsersWhereaboutsOptionSelected = (state: AppState) => state.favouritedUsersWhereabouts.isFavouritedUserOptionSelected;
